import { deletePrescription } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PrescriptionMessageT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchDeletePrescription(
  dosespotPrescriptionId: string,
  signal?: AbortSignal
): Promise<PrescriptionMessageT> {
  const config = await createLotusRequestConfig({ signal });

  const response = await deletePrescription(dosespotPrescriptionId, config);
  return lotusHealthZod.deletePrescriptionResponse.parse(response.data) as PrescriptionMessageT;
}
